import React from 'react';
import styled from 'styled-components';
import { ReactComponent as BabyfaceIcon } from '../../../lib/image/icons/logo/bLogo.svg';
import { WAVE_1, WAVE_2, WAVE_3 } from '../../../lib/image/PCBackgroundImages';

const PCBackground = () => {
  return (
    <>
      <PCBackgroundWave />
      <LogoContatiner>
        <LeftLogo />
        <RightLogo />
      </LogoContatiner>
    </>
  );
};

export default PCBackground;

const PCBackgroundWave = styled.div`
  position: fixed;
  top: 500px;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fcf6f9;
  background-image: url(${WAVE_1}), url(${WAVE_2}), url(${WAVE_3});
  background-size: contain;
`;

const LogoContatiner = styled.div`
  @media screen and (max-width: 1200px) {
    display: none;
  }
`;

const LeftLogo = styled(BabyfaceIcon)`
  position: fixed;
  top: 0;
  left: 0;
  width: 18rem;
  height: 14.625rem;
`;

const RightLogo = styled(BabyfaceIcon)`
  position: fixed;
  top: -245px;
  right: 0;
  width: 8.5rem;
`;
